import { render, staticRenderFns } from "./SendOpinionPage.vue?vue&type=template&id=59882ba8&"
import script from "./SendOpinionPage.vue?vue&type=script&lang=js&"
export * from "./SendOpinionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports